<template>
    <div
        class="keyfigure"
    >
        <div class="caption text" v-html="layout.caption"/>
        <Parallax :power="0.1">
            <img :src="layout.image"/>
        </Parallax>
    </div>
</template>
<script>
import Parallax from '@/components/animation/Parallax'
export default {
    components: {
        Parallax
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.keyfigure
    margin-bottom: 10%
    margin-top: 10%
.caption
    margin-left: 0
    background-color: #ff2b2a
    padding-left: 10.41667%
    padding-bottom: 6%
    padding-top: 10%
    min-width: 50%
    padding-right: 16%
    display: inline-block
    z-index: 1
    position: relative
    @include media-breakpoint-down($lg)
        padding-left: 72 / 750 * 100%
        padding-right: 72 / 750 * 100%
        width: 100%
        display: block
        max-width: 100%
    /deep/ h1
        color: #ffffff !important
        font-size: 8.33vw
        &+h1
            margin-top: 0
        @include media-breakpoint-up($xxl)
            font-size: 160px

img
    width: 50%
    height: auto
    margin-left: auto
    margin-right: 10.41667%
    display: block
    margin-top: -17%
    position: relative
    z-index: -1
    @include media-breakpoint-down($lg)
        width: 100%
        margin-top: 0
        margin-right: 0
</style>
